import React from 'react';
import { useBrand } from '../context/BrandContext';

const BrandLogo = ({
  size = 'md',
  showText = true,
  title,
  subtitle,
  className = ''
}) => {
  const { brandConfig } = useBrand();
  // Size variants
  const sizeClasses = {
    sm: {
      container: 'w-12 h-12',
      logo: 'w-full p-1.5',
      fallback: 'text-lg',
      title: 'text-xl',
      subtitle: 'text-xs'
    },
    md: {
      container: 'w-16 h-16',
      logo: 'w-full p-2',
      fallback: 'text-xl',
      title: 'text-2xl',
      subtitle: 'text-sm'
    },
    lg: {
      container: 'w-20 h-20',
      logo: 'w-full p-2.5',
      fallback: 'text-2xl',
      title: 'text-3xl',
      subtitle: 'text-base'
    }
  };

  const sizes = sizeClasses[size];

  return (
    <div className={`text-center ${className}`}>
      <div className="flex justify-center mb-6">
        <div className={`${sizes.container} bg-brand-600 rounded-2xl flex items-center justify-center shadow-lg`}>
          <img
            src={brandConfig.logo}
            alt={`${brandConfig.name} Logo`}
            className={`${sizes.logo} flex`}
            onError={(e) => {
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'block';
            }}
          />
          <div className={`text-white font-bold ${sizes.fallback} hidden`}>{brandConfig.logoFallback}</div>
        </div>
      </div>
      
      {showText && (
        <>
          <h2 className={`${sizes.title} font-bold text-gray-900 mb-2`}>
            {title || brandConfig.name}
          </h2>
          {subtitle && (
            <p className={`text-gray-600 ${sizes.subtitle}`}>
              {subtitle}
            </p>
          )}
        </>
      )}
    </div>
  );
};

export default BrandLogo;
